import { render } from "./RouteEditor.vue?vue&type=template&id=2b88cee0&scoped=true"
import script from "./RouteEditor.vue?vue&type=script&lang=js"
export * from "./RouteEditor.vue?vue&type=script&lang=js"

import "./RouteEditor.vue?vue&type=style&index=0&id=2b88cee0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b88cee0"]])

export default __exports__